import { createFileRoute } from '@tanstack/react-router';

import { SizeSetsPage, sizeSetsQueryOptions } from '@/features/dictionary';

/** The list carries every set with its sizes, so prefetching it also fills the editor. */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup/size-sets/$sizeSetId')({
  loader: async ({ context, params }) => {
    const sets = await context.queryClient
      .query({ ...sizeSetsQueryOptions(), staleTime: 'static' })
      .catch(() => undefined);
    return { crumb: sets?.find((set) => set.id === params.sizeSetId)?.name };
  },
  component: SizeSetRoute,
});

function SizeSetRoute() {
  const { sizeSetId } = Route.useParams();
  return <SizeSetsPage view={{ sizeSetId }} />;
}
